import {gql} from '@apollo/client';
import {toRelayId, useMutation$} from 'graphqlsupport';
import {Offer} from 'offer';

type CancelOfferInput = {
    offerGuid: string;
}
type CancelOfferResult = {
    cancelOffer: Partial<Offer>;
};
const CANCEL_OFFER_MUTATION = gql`
mutation ($offerGuid: ID!) {
  cancelOffer(
    id: $offerGuid
  ) {
    id
    guid
  }
}
`;
export const useCancelOffer$ = (offerGuid: string) => {
    return useMutation$<CancelOfferInput, CancelOfferResult>(CANCEL_OFFER_MUTATION, {
        variables: {
            offerGuid: toRelayId(offerGuid, 'Offer'),
        }
    });
}
